import { logOut } from "@/src/auth/store/auth-slice";
import { resetIdentity } from "@/src/common/lib/identify";
import { logger } from "@/src/common/lib/logger";
import { createAppThunk } from "@/src/common/redux/create-app-thunk";
import { persistor } from "@/src/common/redux/store";
import { baseApi } from "@/src/common/services/base-api";
import { getRefreshToken, httpClient } from "@/src/common/services/http.service";

export const LOGOUT_BROADCAST_KEY = "upsquad:logout-broadcast";

interface LogOutOptions {
	silent?: boolean;
	skipRedirect?: boolean;
	revokeAll?: boolean;
}

export const logOutAndReset = createAppThunk<void, LogOutOptions | undefined>("auth/logOutAndReset", async (options, { dispatch }) => {
	const refresh_token = getRefreshToken() ?? undefined;

	try {
		await httpClient.auth.logout.post({ refresh_token, revoke_all: options?.revokeAll ?? false });
	} catch (err) {
		logger.error("logout failed", err);
	}

	dispatch(baseApi.util.resetApiState());

	dispatch(logOut());
	resetIdentity();

	await persistor.flush();

	if (!options?.silent) {
		try {
			window.localStorage.setItem(LOGOUT_BROADCAST_KEY, String(Date.now()));
			window.localStorage.removeItem(LOGOUT_BROADCAST_KEY);
		} catch {}
	}

	if (!options?.skipRedirect && !window.location.pathname.startsWith("/auth")) {
		window.location.replace(`${window.location.origin}/auth`);
	}
});
